export enum PARTNER_OBJECT_TYPE {
  ACCOUNT = '101',
  AGENT = '111',
  BROKER = '121',
  MERCHANT = '131',
  AIA = '141',
  STC = '151',
  EMPLOYEE = '201'
};
